import { BroadcastTutorialStep } from './broadcast';

/**
 * Сырые данные настроек пользователя от DataSync.
 * Все поля опциональны, так как DataSync может вернуть частичный объект или пустой объект.
 */
type RawUserSettings = Partial<{
    broadcastTutorialStep: BroadcastTutorialStep;
    broadcastCaptionTooltipShown: boolean;
    checkDesktopAppExistence: boolean;
    gridView2: string;
    isShownLimitMessage: boolean;
    joinWithCameraOff: boolean;
    joinWithMicrophoneOff: boolean;
    showMyVideo: boolean;
    summarizationStartPopupWasShown: boolean;
    summarizationWelcomePopupWasShown: boolean;
}>;

/**
 * Нормализованные настройки пользователя с дефолтными значениями.
 */
export interface UserSettings {
    broadcastTutorialStep: BroadcastTutorialStep;
    broadcastCaptionTooltipShown: boolean;
    checkDesktopAppExistence: boolean;
    gridView2: string;
    isShownLimitMessage: boolean;
    joinWithCameraOff: boolean;
    joinWithMicrophoneOff: boolean;
    showMyVideo: boolean;
    summarizationStartPopupWasShown: boolean;
    summarizationWelcomePopupWasShown: boolean;
}

export enum VirtualBackgroundType {
    NONE = 'none',
    BLURRED = 'blurred',
}

export enum NoiseCancellationType {
    DISABLED = 'disabled',
    AUTO = 'auto',
    LOW = 'low',
    HIGH = 'high',
}
export interface QuerySettings {
    deviceProcessors: {
        noiseCancellationType?: NoiseCancellationType;
        virtualBackground?: VirtualBackgroundType;
    };
    hideParticipantsVideo?: boolean;
    showMyVideo?: boolean;
}
/**
 * Дефолтные значения для настроек пользователя
 */
export const DEFAULT_USER_SETTINGS: UserSettings = {
    broadcastTutorialStep: BroadcastTutorialStep.CREATED,
    broadcastCaptionTooltipShown: false,
    checkDesktopAppExistence: true,
    gridView2: '',
    isShownLimitMessage: false,
    joinWithCameraOff: false,
    joinWithMicrophoneOff: false,
    showMyVideo: true,
    summarizationStartPopupWasShown: false,
    summarizationWelcomePopupWasShown: false,
};

export enum CustomTheme {
    LIGHT = 'light',
    DARK = 'dark',
}

/**
 * Нормализует сырые настройки пользователя, применяя дефолтные значения
 * @param rawSettings - Сырые настройки от DataSync
 * @returns Нормализованные настройки со всеми обязательными полями
 */
export function normalizeUserSettings(rawSettings: RawUserSettings): UserSettings {
    return {
        ...DEFAULT_USER_SETTINGS,
        ...rawSettings,
    };
}
